import { FormGroup, UntypedFormControl, ValidationErrors } from '@angular/forms';

export function intelligentActionValidator(
  control: FormGroup
): ValidationErrors | null {
    const actualControl = control.controls['actualControl']
    const extractedControl = control.controls['extractedControl']
    const value = control.value;

    return actualControl && 
     actualControl.value && 
     extractedControl &&
     extractedControl.value &&
     actualControl.value !== extractedControl.value &&
     (actualControl.value as string).toLowerCase() !== (extractedControl.value as string).toLowerCase()
        ? {
            mismatchIntelligentAction: true,
        }
        : null;
}
